export default {
    install(Vue, Options) {
        /***
         * 防抖 单位时间只触发最后一次
         *  @param {?Number|300} time - 间隔时间
         *  @param {Function} fn - 执行事件
         *  @param {?String|"click"} event - 事件类型 例："click"
         *  @param {Array} binding.value - [fn,event,time]
         *  例：<el-button v-debounce="[reset,`click`,300]">刷新</el-button>
         *  也可简写成：<el-button v-debounce="[reset]">刷新</el-button>
         */
        Vue.directive('debounce', {
            inserted: function (el, binding) {
                let [fn, event = "click", time = 300] = binding.value
                let timer
                el.addEventListener(event, () => {
                    timer && clearTimeout(timer)
                    // timer = setTimeout(() => {}, time)
                    timer = setTimeout(() => fn(), time);//input的change事件
                })
            }
        })
        /***
         *  节流 每单位时间可触发一次
         *  第一次瞬间触发，最后一次不管是否达到间隔时间依然触发
         * 【考虑到input的change事件】
         *  @param {?Number|300} time - 间隔时间
         *  @param {Function} fn - 执行事件
         *  @param {?String|"click"} event - 事件类型 例："click"
         *  @param {Array} binding.value - [fn,event,time]
         *  例：<el-button v-throttle="[reset,`click`,300]">刷新</el-button>
         *  传递参数则：<el-button v-throttle="[()=>reset(param),`click`,300]">刷新</el-button>
         */
        Vue.directive('throttle', {
            inserted: function (el, binding) {
                let [fn, event = "click", time = 300] = binding.value
                let timer, timer_end;
                el.addEventListener(event, () => {
                    if (timer) {
                        clearTimeout(timer_end);
                        return timer_end = setTimeout(() => {}, time); //普通点击事件
                    }
                    fn();
                    timer = setTimeout(() => timer = null, time)
                }, true)
            }
        })
        Vue.directive('color', {
            inserted: function (el, binding) {
                if(!binding.value && binding.value != '0'){
                    el.style.color='#333'
                    el.innerText = '--'
                    return
                }
                let val = binding.value && binding.value.toString()
                if(val == '0' || val == '0.00'){
                    el.style.color='#333'
                    el.innerText = '0.00' + '%'
                }else if(val.indexOf('-') > -1){
                    el.style.color='#00b578'
                    el.innerText =  binding.value + '%'
                }else {
                    el.style.color='#e12817'
                    el.innerText = '+' + binding.value + '%'
                }
            },
            update:function (el, binding) {
                if(!binding.value && binding.value != '0'){
                    el.style.color='#333'
                    el.innerText = '--'
                    return
                }
                let val = binding.value && binding.value.toString()
                if(val == '0' || val == '0.00'){
                    el.style.color='#333'
                    el.innerText = '0.00' + '%'
                }else if(val.indexOf('-') > -1){
                    el.style.color='#00b578'
                    el.innerText =  binding.value + '%'
                }else {
                    el.style.color='#e12817'
                    el.innerText = '+' + binding.value + '%'
                }
            }
        });

        Vue.directive('color-if', {
            inserted: function (el, binding) {
                if(!binding.value && binding.value != '0'){
                    el.style.color='#333'
                    el.innerText = '--'
                    return
                }
                let val = binding.value && binding.value.toString()
                if(val == '0' || val == '0.00'){
                    el.style.color='#333'
                    el.innerText = '0.00'
                }else if(val.indexOf('-') > -1){
                    el.style.color='#00b578'
                    el.innerText =  Number(binding.value).toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      });
                }else {
                    el.style.color='#e12817'
                    el.innerText = '+' + Number(binding.value).toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      });
                }
            },
            update:function (el, binding) {
                if(!binding.value && binding.value != '0'){
                    el.style.color='#333'
                    el.innerText = '--'
                    return
                }
                let val = binding.value && binding.value.toString()
                if(val == '0' || val == '0.00'){
                    el.style.color='#333'
                    el.innerText = '0.00'
                }else if(val.indexOf('-') > -1){
                    el.style.color='#00b578'
                    el.innerText =  Number(binding.value).toLocaleString();
                }else {
                    el.style.color='#e12817'
                    el.innerText = '+' + Number(binding.value).toLocaleString();
                }
            }
        });

        // 创建一个全局自定义指令 k
        Vue.directive('outer-click', {
            bind(el, binding, vnode) {
            // 定义一个处理点击事件的函数
            el.clickOutsideEvent = function(event) {
                // 检查点击的元素是否是指令绑定的元素或者其子元素
                if (!(el === event.target || el.contains(event.target))) {
                // 点击发生在元素外部，执行绑定的表达式
                binding.value(event);
                }
            };
            
            // 在document上添加点击事件监听器
            document.addEventListener('click', el.clickOutsideEvent);
            },
            
            unbind(el) {
            // 指令解绑时，移除事件监听器
            document.removeEventListener('click', el.clickOutsideEvent);
            },
        });
    }
}

